import React from 'react';

import DeleteBtn from '../Base/DeleteBtn';
import SpaceConfigs from '../Base/SpaceConfigs';
import BackgroundConfigs from '../Base/BackgroundConfigs';
import FontConfigs from '../Base/FontConfigs';
import DuplicateBtn from '../Base/DuplicateBtn';
import AvoidCollisionSwitch from '../Base/AvoidCollisionSwitch';

import { ISpace } from '../../../../types/space';
import { ElementTypes } from '../../../../types/element';
import { ELEMENTS_THAT_CAN_AVOID_COLLISION } from '../../../../constants/space';

interface IProps {
  space: ISpace<ElementTypes>;
}

class EditFormFieldText extends React.PureComponent<IProps> {
  public render() {
    const { space } = this.props;

    return (
      <>
        <SpaceConfigs space={space} isAvoidCollision={space.isAvoidCollision} />
        {ELEMENTS_THAT_CAN_AVOID_COLLISION[space.type] && (
          <AvoidCollisionSwitch spaceId={space.id} isAvoidCollision={space.isAvoidCollision} />
        )}
        <FontConfigs space={space} />
        <BackgroundConfigs space={space} />
        <DuplicateBtn spaceId={space.id} />
        <DeleteBtn />
      </>
    );
  }
}

export default EditFormFieldText;
